import OfertaShow from './OfertaShow.vue'

export default OfertaShow

